import { useEffect, useState } from 'react';

/**
 * Trailing-edge debounce for a rapidly-changing value — typically search input on its way to a
 * network request.
 *
 * Returns the previous value until `delay` has elapsed with no further change, so the caller
 * can render every keystroke immediately while only querying on the settled value.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
